import React from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import isNil from 'ramda/src/isNil';
import values from 'ramda/src/values';
import CheckIcon from '@components/@core/CheckIcon';
import Pagination from '@components/@core/Pagination';
import { ProgramQuotaTooltip } from '@components/ScorecardToolTips';
import { QuotaCalcTypes, QuotaRequirement } from '~/services/config';
import { getUnit, inPage, length } from '~/services/util';

const quotaCalcTypes = values(QuotaCalcTypes);

class QuotasDetail extends React.PureComponent {
    state = { current: 1, per: 5 };

    handlePagination = (e) => {
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.setState({ per: e });
    };

    render() {
        const { current, per } = this.state;
        const { data, type } = this.props;

        return (
            <div className="career-required-instances">
                <div className="quotas">
                    {data?.map((item, index) => {
                        const quotaCalculation = type === 'instance' ? item.data.quota_calculation : item.quota_calculation;
                        const quotaRequirement = type === 'instance' ? item.data.quota_direction : item.quota_direction;
                        const quotaTarget = type === 'instance' ? item.data.quota_target : item.quota_target;
                        return (
                            inPage(index, current, per) && (
                                <div className="list d-flex ssm-column py-4" key={`qt-${index}`}>
                                    <div className="d-h-start d-flex-6">
                                        <CheckIcon className="my-auto" size={26} checked={!isNil(item.completed_at)} />
                                        <div className="ms-2">
                                            <OverlayTrigger placement="bottom" overlay={ProgramQuotaTooltip(item)}>
                                                <p className="dsl-b16 text-400 mb-1">{item?.name || item.data.name}</p>
                                            </OverlayTrigger>
                                        </div>
                                    </div>
                                    <div className="d-flex-3">
                                        <p className="dsl-b16 mb-1">{quotaCalcTypes[quotaCalculation] ? quotaCalcTypes[quotaCalculation].label : quotaCalcTypes[0].label}</p>
                                    </div>
                                    <div className="d-flex-3">
                                        <p className="dsl-b16 mb-1">{QuotaRequirement[quotaRequirement - 1] ? QuotaRequirement[quotaRequirement - 1].name : QuotaRequirement[0].name}</p>
                                    </div>
                                    <div className="d-flex-1 ssm-left">
                                        <p className="dsl-b16 mb-1">{getUnit(quotaTarget, item.data.target_types)}</p>
                                    </div>
                                    {this.props.programType == 'certificate' && (
                                        <div className="d-flex-1 ssm-left">
                                            <p className="dsl-b16 mb-1">{length(item?.actuals)}</p>
                                        </div>
                                    )}
                                    <div className="d-flex-2 ssm-left">
                                        <p className="dsl-b16 mb-1">{!isNil(item.completed_at) ? 'Completed' : 'Incomplete'}</p>
                                    </div>
                                </div>
                            )
                        );
                    })}
                </div>
                {data?.length >= 10 && <Pagination current={current} per={per} pers={[5, 10, 'all']} total={Math.ceil(data.length / per)} onChange={this.handlePagination} onPer={this.handlePer} />}
            </div>
        );
    }
}

QuotasDetail.propTypes = {
    data: PropTypes.array,
    type: PropTypes.oneOf(['instance', 'template']),
    programType: PropTypes.string,
};

QuotasDetail.defaultProps = {
    data: [],
    type: 'instance',
    programType: '',
};

export default QuotasDetail;
